import { ScreenEnum } from '../../hooks/navigation/Screens';

export const PAYOUT_STATUSES = {
  created: 'created',
  processing: 'processing',
  paid: 'paid',
  failed: 'failed',
};

export const PAYOUT_PROVIDERS = {
  stripe: 1,
  paypal: 2,
  cash: 3,
};

export const PROMO_CODE_TYPES = {
  single_use: 'single_use',
  multi_use: 'multi_use',
};

export const PROMO_CODE_DISCOUNT_TYPES = {
  fixed_amount: 'fixed_amount',
  percentage: 'percentage',
};

export const PromoCodeTag = {
  Master: 'master',
  Campaign: 'campaign',
  OneTime: 'one_time',
};

export const PromoCodeCreatedBy = {
  User: 'user',
  System: 'system',
};

export const CustomerBonusType = {
  Welcome: 'welcome',
  AppSignup: 'app_signup',
};

export const ORDER_METHODS = {
  pickup: 'pickup',
  delivery: 'delivery',
  room_service: 'room_service',
};

export const ORDER_PAYMENT_STATUSES = {
  pending: 'pending',
  paid: 'paid',
  partially_refunded: 'partially_refunded',
  refunded: 'refunded',
};

export const FULFILLMENT_STATUSES = {
  created: 'created',
  reviewed: 'reviewed',
  accepted: 'accepted',
  preparing: 'preparing',
  ready: 'ready',
  on_delivery: 'on_delivery',
  picked: 'picked',
  rejected: 'rejected',
};

export const CATEGORY_TYPES = {
  DEFAULT: 'default',
  FAVOURITES: 'favourites',
  FREE_ITEMS: 'free_items',
  MOST_POPULAR: 'most_popular',
};

export const PRODUCT_TYPES = {
  PRODUCT: 'product',
  DEFAULT: 'default',
  FAVOURITES: 'favourites',
  FREE_ITEMS: 'free_items',
  MOST_POPULAR: 'most_popular',
};

export const InvoiceType = {
  Manual: 'manual',
  SetupFee: 'setup_fee',
  Subscription: 'subscription',
};

export const InvoiceStatus = {
  Pending: 'pending',
  Processing: 'processing',
  Paid: 'paid',
  PartiallyRefunded: 'partially_refunded',
  Refunded: 'refunded',
  Failed: 'failed',
};

export const BillingMode = {
  Stripe: 'stripe',
  InternalInvoicing: 'internal_invoicing',
};

export const SignatureProvider = Object.freeze({
  Yousign: 'yousign',
  SelfHosted: 'selfhosted',
});

/**
 * Signing flow identifiers sent to the backend so it can branch on how the
 * signature request was initiated.
 */
export const ContractFlow = Object.freeze({
  SwitchToAnnual: 'switch_to_annual',
});

export const SubscriptionTerm = {
  Monthly: 'monthly',
  Annual: 'annual',
};

export const SetupPackageType = {
  Default: 'default',
  Preferred: 'preferred',
  Custom: 'custom',
};

export const CATEGORY_TYPES_OPTIONS = [
  {
    label: 'Default',
    value: CATEGORY_TYPES.DEFAULT,
  },
  {
    label: 'Favourites',
    value: CATEGORY_TYPES.FAVOURITES,
  },
];

export const PROMO_CODE_DISCOUNT_TYPE_CASES = [
  {
    value: PROMO_CODE_DISCOUNT_TYPES.fixed_amount,
    label: 'Fixed amount',
  },
  {
    value: PROMO_CODE_DISCOUNT_TYPES.percentage,
    label: 'Percentage',
  },
];

export const IDENTIFIERS = [
  {
    value: 'vgn',
    label: 'Vegan',
  },
  {
    value: 'vgt',
    label: 'Vegetarian',
  },
  {
    value: 'gf',
    label: 'Gluten free',
  },
  {
    value: 'df',
    label: 'Dairy free',
  },
  {
    value: 'hal',
    label: 'Halal',
  },
  {
    value: 'h&s',
    label: 'Spicy',
  },
];

export const DAYS = [0, 1, 2, 3, 4, 5, 6];

export const SCHEDULED_ORDERS_TIME_SLOT_INTERVAL_OPTIONS = [5, 10, 15, 20, 30];

export const ORDER_EXTRA_TIME_OPTIONS = [0, 2, 3, 5, 7, 10];

export const ORDER_APPROVAL_TIME_STEP_OPTIONS = [5, 10, 15];

export const LAST_ORDER_GAP_OPTIONS = [0, 5, 15, 30, 45, 60, 90];

export const COUPON_TYPES = {
  REWARD: 1,
  CASHBACK: 2,
  PROMO_CODE: 3,
  GIFT_CARD: 4,
};

export const DELIVERY_ZONE_GEOMETRY_TYPES = {
  CIRCLE: 'circle',
  POLYGON: 'polygon',
  ZIP: 'zip',
};

export const PaymentGatewayVerificationStatus = {
  Pending: 'pending',
  Verified: 'verified',
  Rejected: 'rejected',
};

export const BusinessType = {
  Company: 'company',
  Individual: 'individual',
};

export const OnboardingStep = {
  EmailVerification: 'email_verification',
  BusinessInfo: 'business_info',
  PersonalInfo: 'personal_info',
  ShippingInfo: 'shipping_info',
  BankInfo: 'bank_info',
  TaxInfo: 'tax_info',
  PersonalDocs: 'personal_doc',
  BusinessDocs: 'business_doc',
  InfoSubmission: 'confirm_info',
  PaymentInfo: 'payment_info',
  Subscription: 'subscription',
  MobileApp: 'mobile_app',
  DeliveryStructure: 'delivery_structure',
  Contract: 'contract',
  ContractPayment: 'contract_payment',
  PromoCode: 'promo_code',
};

export const StripeDocumentType = {
  OwnerDocument: 'owner_document',
  BusinessDocument: 'business_document',
};

export const OwnerDocumentKinds = ['passport', 'driver_license', 'id_card', 'residence_permit'];

export const BusinessDocumentKinds = [
  'vat_registration',
  'trade_registration',
  'trade_license',
  'commercial_register_extract',
  'financial_statements',
  'other',
];

// Selectable document kinds per document type.
export const DocumentKindsByType = {
  [StripeDocumentType.OwnerDocument]: OwnerDocumentKinds,
  [StripeDocumentType.BusinessDocument]: BusinessDocumentKinds,
};

export const PaymentGateway = {
  Stripe: 'stripe',
  Adyen: 'adyen',
};

export const PaymentMethods = {
  CARD: 'card',
  PAYPAL: 'paypal',
  APPLE_PAY: 'apple_pay',
  GOOGLE_PAY: 'google_pay',
  LINK: 'link',
  SOFORT: 'sofort',
  GIROPAY: 'giropay',
  SEPA_DEBIT: 'sepa_debit',
  CASH: 'cash',
  BACS_DEBIT: 'bacs_debit',
  PAY_BY_BANK: 'pay_by_bank',
  IDEAL: 'ideal',
  BANCONTACT: 'bancontact',
  EPS: 'eps',
  P24: 'p24',
  BLIK: 'blik',
  TWINT: 'twint',
  VENMO: 'venmo',
  WERO: 'wero',
  KLARNA: 'klarna',
  TRUSTLY: 'trustly',
  PIX: 'pix',
  NUPAY: 'nupay',
};

/**
 * Brand names of the local methods a partner's Spreedly gateway can take. Brands are not
 * translated, so these read the same in every language.
 */
export const OFFSITE_PAYMENT_METHOD_NAMES = {
  [PaymentMethods.IDEAL]: 'iDEAL | Wero',
  [PaymentMethods.BANCONTACT]: 'Bancontact',
  [PaymentMethods.EPS]: 'EPS',
  [PaymentMethods.P24]: 'Przelewy24',
  [PaymentMethods.BLIK]: 'BLIK',
  [PaymentMethods.TWINT]: 'TWINT',
  [PaymentMethods.PAYPAL]: 'PayPal',
  [PaymentMethods.VENMO]: 'Venmo',
  [PaymentMethods.WERO]: 'Wero',
  [PaymentMethods.KLARNA]: 'Klarna',
  [PaymentMethods.TRUSTLY]: 'Trustly',
  [PaymentMethods.PIX]: 'Pix',
  [PaymentMethods.NUPAY]: 'NuPay',
};

/**
 * The currencies each local method is offered in, mirroring the backend's
 * PaymentMethod::presentmentCurrencies(). Checkout never shows a method outside
 * them, so the modal says so rather than let a partner switch on one that can
 * never appear.
 */
export const OFFSITE_PAYMENT_METHOD_CURRENCIES = {
  [PaymentMethods.IDEAL]: ['EUR'],
  [PaymentMethods.BANCONTACT]: ['EUR'],
  [PaymentMethods.EPS]: ['EUR'],
  [PaymentMethods.P24]: ['EUR', 'PLN'],
  [PaymentMethods.BLIK]: ['PLN'],
  [PaymentMethods.TWINT]: ['CHF'],
  [PaymentMethods.VENMO]: ['USD'],
  [PaymentMethods.WERO]: ['EUR'],
  [PaymentMethods.KLARNA]: ['EUR', 'GBP', 'CHF', 'DKK', 'NOK', 'SEK', 'PLN', 'CZK'],
  [PaymentMethods.TRUSTLY]: ['EUR', 'GBP', 'DKK', 'NOK', 'SEK'],
  [PaymentMethods.PIX]: ['BRL'],
  [PaymentMethods.NUPAY]: ['BRL'],
};

/** Whether a local method can show at checkout for a partner charging in `currency` (unknown: yes). */
export const offsiteMethodPresentsIn = (method, currency) =>
  !currency ||
  !OFFSITE_PAYMENT_METHOD_CURRENCIES[method] ||
  OFFSITE_PAYMENT_METHOD_CURRENCIES[method].includes(currency);

export const FeatureFlags = {
  PaypalStandalone: 'paypal_standalone',
  CustomStoreSeo: 'custom_store_seo',
  MerchantBilling: 'merchant_billing',
  ExternalPrinter: 'external_printer',
  IssueEndCustomerReceipts: 'issue_end_customer_receipts',
  PlgOnboarding: 'plg_onboarding',
  ProviderBilling: 'provider_billing',
  PartnerCustomDashboardDomain: 'partner_custom_dashboard_domain',
  PartnerCustomShopDomain: 'partner_custom_shop_domain',
  StripeDestinationCharges: 'stripe_destination_charges',
};

/**
 * Channels a service provider may notify on (`notification_channels` on the
 * provider payload). Email is always on; WLP partners have no Twilio account,
 * so they are email-only.
 */
export const NotificationChannel = {
  Email: 'email',
  Sms: 'sms',
  WhatsApp: 'whatsapp',
  VoiceCall: 'voice_call',
  Push: 'push',
};

/** Mirrors the backend's App\Constants\ServiceProvider\MessengerAudience. */
export const MessengerAudience = {
  Everyone: 'everyone',
  PartnerAdmins: 'partner_admins',
  Nobody: 'nobody',
};

export const ONBOARDING_GUIDE_STEPS = {
  Notifications: 'notifications',
  WhatsApp: 'notifications#whatsapp',
  Voice: 'notifications#voice',

  OpenTimesAndLocation: 'open_times_and_location',
  OpenTimes: 'open_times_and_location#open_times',
  Location: 'open_times_and_location#location',

  Identity: 'identity',

  OrderSettings: 'order_settings',
  PickupTime: 'order_settings#pickup_time',
  DeliveryTime: 'order_settings#delivery_time',
  StaffCredentials: 'order_settings#staff_credentials',

  Menu: 'menu',
  ImportMenu: 'menu#import_menu',
  Favourites: 'menu#favourites',
  SoldOutItems: 'menu#sold_out_items',

  Marketing: 'marketing',
  FeaturedPosts: 'marketing#featured_posts',
  PromoCodes: 'marketing#promo_codes',
  GoogleBusiness: 'marketing#google_business',

  MyStore: 'my_store',
  Gallery: 'my_store#gallery',
  LogoAndPrimaryColor: 'my_store#logo_and_primary_color',

  GoLive: 'go_live',
  OrderFlyers: 'go_live#order_flyers',
  CreateStorefront: 'go_live#create_storefront',
  EnableLiveOrders: 'go_live#enable_live_orders',

  Complete: 'complete',
};

export const NotificationType = {
  PaymentGatewayVerificationPending: 'App\\Notifications\\Merchant\\Onboarding\\PaymentGatewayVerificationPending',
  PaymentGatewayVerificationSuccessful:
    'App\\Notifications\\Merchant\\Onboarding\\PaymentGatewayVerificationSuccessful',
  PaymentGatewayVerificationFailed: 'App\\Notifications\\Merchant\\Onboarding\\PaymentGatewayVerificationFailed',
};

export const SubscriptionProductType = {
  Plan: 'plan',
  LegacyPlan: 'legacy_plan',
  GoogleAdsPlan: 'google_ads_plan',
  MobileAppPlan: 'mobile_app_plan',
  AddOn: 'add_on',
};

export function getRuntimeEnvironment() {
  // Primary source: the build-time env var Vercel injects per environment
  // (Production -> production, Preview -> staging, dev -> development). It is lowercase
  // and maps 1:1 to the return union, so it is authoritative and removes the fragile
  // hostname matching — in particular `*.vercel.app` previews no longer fall through to
  // `production` and read the wrong `AUTH_TOKEN_${env}` cookie -> 401 (FOO-4501/FOO-4497).
  const mode = import.meta.env.VITE_APP_MODE;
  if (mode === 'localhost' || mode === 'development' || mode === 'staging' || mode === 'production') {
    return mode;
  }

  // Fallback: derive from the hostname when the env var is absent (local `vite dev`).
  // Matches BOTH the hyphenated FoodAmigos form (`restaurant-staging.foodamigos.io`) and
  // the dotted white-label form (`restaurant.staging.orders-portal.com`).
  const { hostname } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'localhost';
  const labels = hostname.split('.');
  if (hostname.includes('-dev') || labels.includes('dev')) return 'development';
  if (hostname.includes('-staging') || labels.includes('staging')) return 'staging';

  return 'production';
}

// The storefront-dashboard / website-studio URLs live in services/branding/managerAppUrls.js.

export const COOKIES = {
  AUTH_TOKEN: `AUTH_TOKEN_${getRuntimeEnvironment()}`,
  ON_BEHALF_OF_STORE: `ON_BEHALF_OF_STORE_${getRuntimeEnvironment()}`,
  // Published (apex-scoped, env-suffixed) so the storefront dashboard can send its
  // "Admin Dashboard" back-link to THIS admin dashboard's host — a white-label manager on
  // restaurant.orders-portal.com returns to that host, not restaurant*.foodamigos.io.
  // FOO-4519 / FOO-4497.
  ADMIN_DASHBOARD_HOST: `ADMIN_DASHBOARD_HOST_${getRuntimeEnvironment()}`,
};

export const HELLOPRINT_SERVICE_LEVELS = {
  SAVER: 'saver',
  STANDARD: 'standard',
  EXPRESS: 'express',
};

export const HELLOPRINT_ORDER_STATUSES = {
  ORDER_CREATED: 'ORDER_CREATED',
  DELIVERED: 'DELIVERED',
  SHIPPED: 'SHIPPED',
};

export const MenuProvider = {
  Lieferando: 'lieferando',
  Wolt: 'wolt',
  Deliveroo: 'deliveroo',
  UberEats: 'uber_eats',
  Tabless: 'tabless',
  Foodamigos: 'foodamigos',
  // GloriaFood is presented to users as its own source but imports via the
  // FoodBooking ordering page; the backend provider value is the internal
  // canonical `gloria_food` (shop-backend maps the external FoodBooking
  // storefront to it). The key matches the brand; the external FoodBooking
  // storefront naming survives only in the URL validator/labels.
  GloriaFood: 'gloria_food',
  // DoorDash store pages (US, CA, AU), read through Actowiz like Uber Eats.
  DoorDash: 'doordash',
  // The Just Eat Takeaway brands. One platform read by one scraper driver, but
  // separate providers here on purpose: an operator picks the site they actually
  // know theirs by, and RegionalConfig.supported_menu_providers then surfaces
  // only the brand that operates in their market (NL sees Thuisbezorgd, UK sees
  // Just Eat). shop-backend collapses them to the canonical `just_eat` before
  // calling the scraper, which resolves the market from the listing URL.
  Thuisbezorgd: 'thuisbezorgd',
  TakeawayCom: 'takeaway_com',
  PysznePl: 'pyszne_pl',
  BistroSk: 'bistro_sk',
  JustEat: 'just_eat',
};

// Providers the menu-import flow actually supports — mirrors shop-backend's
// MenuProvider::initiatable(). Regional configs may list additional providers
// that have no import pipeline; the import dropdown must only offer these, or
// the user gets a guaranteed validation error from the backend.
export const IMPORTABLE_MENU_PROVIDERS = [
  MenuProvider.Lieferando,
  MenuProvider.Wolt,
  MenuProvider.Deliveroo,
  MenuProvider.UberEats,
  MenuProvider.GloriaFood,
  MenuProvider.DoorDash,
  MenuProvider.Foodamigos,
  MenuProvider.Thuisbezorgd,
  MenuProvider.TakeawayCom,
  MenuProvider.PysznePl,
  MenuProvider.BistroSk,
  MenuProvider.JustEat,
];

export const TAX_BEHAVIOUR = {
  inclusive: 'inclusive',
  exclusive: 'exclusive',
};

export const SCHEDULE_EXCEPTION_TYPES = {
  CLOSED: 'closed',
  OPENED: 'opened',
  PAUSED: 'paused',
};

export const RESERVATION_STATUS_TYPE = {
  PENDING: 0,
  CONFIRMED: 1,
  CANCELED: 2,
  REJECTED: 4,
  UPDATE_PENDING: 5,
  UPDATE_CONFIRMED: 6,
  REMOVED: 7,
};

export const RESERVATION_SOURCES = {
  WEBSITE: 'website',
  GOOGLE: 'google',
};

export const REFUND_REASONS = {
  RequestedByCustomer: 'requested_by_customer',
  Reclamation: 'reclamation',
  CommunicationError: 'communication_error',
  Dispute: 'dispute',
  Other: 'other',
};

export const ROOM_SERVICE_LOCATION_TYPES = {
  room_service: 'room_service',
  table_service: 'table_service',
};

export const SCHEDULE_EXCEPTION_CATEGORY_TYPES = {
  BREAKFAST: 'breakfast',
  LUNCH: 'lunch',
  DINNER: 'dinner',
};

export const RESERVATION_USER_TYPES = {
  MERCHANT: 0,
  CUSTOMER: 1,
};

export const SCREEN_TYPES = {
  DESKTOP: 'Desktop',
  TABLET: 'Tablet',
  MOBILE: 'Mobile',
};

export const PolygraphyProductType = {
  Flyer: 'flyer',
  DoorSticker: 'door_sticker',
  Sticker: 'sticker',
  Custom: 'custom',
};

export const FlyerTemplate = {
  One: 'one',
  Two: 'two',
  Three: 'three',
  Four: 'four',
};

export const StickerTemplate = {
  One: 'one',
};

export const DoorStickerTemplate = {
  One: 'one',
  Two: 'two',
};

export const PolygraphyProductFormat = {
  FlyerA5: 'flyer_A5',
  FlyerA6: 'flyer_A6',

  DoorStickerA5: 'door_sticker_A5',
  DoorSticker300x300: 'door_sticker_300x300',

  Sticker60x60: 'sticker_60x60',
};

export const PolygraphyProductImageType = {
  Logo: 'logo',
  Cover: 'cover',
  QrCode: 'qr_code',
};

export const PolygraphyProductUrlType = {
  OnlineShop: 'online_shop',
  Storefront: 'storefront',
  Custom: 'custom',
};

export const RESTAURANT_TYPES = {
  PIZZA: 'Pizza',
  PIZZA_DELIVERY: 'PizzaDelivery',
  PIZZA_NEAPOLITAN: 'PizzaNeapolitan',
  ITALIAN: 'Italian',
  BURGER: 'Burger',
  TURKISH: 'Turkish',
  ORIENTAL: 'Oriental',
  MEXICAN: 'Mexican',
  SUSHI: 'Sushi',
  JAPANESE: 'Japanese',
  VIETNAMESE: 'Vietnamese',
  THAI: 'Thai',
  ASIAN: 'Asian',
  INDIAN: 'Indian',
  BOWLS: 'Bowls',
  VEGAN: 'Vegan',
  GREEK: 'Greek',
  CAFE: 'Cafe',
  BRUNCH: 'Brunch',
  SPANISH: 'Spanish',
  PERSIAN: 'Persian',
};

export const PAYOUT_INTERVAL = {
  MANUAL: 'manual',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

export const LEGAL_LANGUAGES = {
  GERMAN: 'de',
  ENGLISH: 'en',
};

export const SMART_PRICING_MODIFIER_TYPE = {
  absolute: 'absolute',
  percentage: 'percentage',
  fixed_value: 'fixed_value',
};

export const SMART_PRICING_RESOURCE_TYPE = {
  franchise: 'App\\Models\\Franchise',
  company: 'App\\Models\\Company',
  menu: 'App\\Models\\Menu',
  category: 'App\\Models\\Category',
  product: 'App\\Models\\Product',
  modifier_group: 'App\\Models\\ModifierGroup',
  modifier: 'App\\Models\\Modifier',
};

export const ENVIRONMENTS = {
  LOCAL: 'localhost',
  DEV: 'development',
  STAGING: 'staging',
  PROD: 'production',
};

export const DeliveryMode = {
  Internal: 'internal',
  External: 'external',
};

// External delivery providers (e.g. Uber Direct) reject deliveries whose dropoff-ready
// time is too close to now, so the delivery order-ahead window must stay at least this
// many minutes in the future whenever external delivery is enabled. Mirrors the backend
// Company::MIN_EXTERNAL_DELIVERY_SCHEDULE_AHEAD_MINUTES.
export const MIN_EXTERNAL_DELIVERY_SCHEDULE_AHEAD_MINUTES = 120;

export const DeliveryProvider = {
  Standalone: 'standalone',
  FirstDelivery: 'first_delivery',
  WoltDrive: 'wolt_drive',
  UberDrive: 'uber_drive',
};

export const PickupTimeOptimizationStrategy = {
  WaitForFirstUpdate: 'wait_for_first_update',
  WaitForDriverAssignment: 'wait_for_driver_assignment',
};

export const DELIVERY_BRAND_BY_PROVIDER = Object.freeze({
  uber_drive: 'Uber',
  wolt_drive: 'Wolt',
  first_delivery: 'Uber',
  standalone: 'Standalone',
});

export const DeliveryCarrier = {
  Uber: 'uber',
  Wolt: 'wolt',
};

export const DeliveryStatus = {
  Pending: 'pending',
  RunnerAssigned: 'runner_assigned',
  OnRoutePickup: 'en_route_pickup',
  ArrivedPickup: 'arrived_pickup',
  PickedUp: 'picked_up',
  OnRouteDropoff: 'en_route_dropoff',
  ArrivedDropoff: 'arrived_dropoff',
  Completed: 'completed',
  Cancelled: 'cancelled',
};

export const TEMPLATE_TYPES = {
  STANDARD: 'standard',
  ELEGANT: 'elegant',
  MODERN: 'modern',
  SIMPLE: 'simple',
  MINIMALIST: 'minimalist',
  COOL: 'cool',
  BOLD: 'bold',
  ASIAN: 'asian',
  PERSIAN: 'persian',
  VIBRANT: 'vibrant',
  CHIC: 'chic',
};

export const RESERVATION_MODELS = {
  FRANCHISE: 'Franchise',
};

export const RESERVATION_MEDIA_TAGS = {
  LOGO: 'logo',
  IMAGES: 'images',
};

export const ProjectsEnum = {
  OnlineShop: 'online_shop',
  Reservations: 'reservations',
  Storefront: 'storefront',
};

export const WEBVIEW_COMMUNICATOR_COMMANDS = {
  NAVIGATE: 'navigate',
  SAVE_LANGUAGE: 'save_language',
  SAVE_WEB_APP_AUTH_TOKEN: 'save_web_app_auth_token',
  REQUEST_ON_BEHALF_OF: 'request_on_behalf_of',
};

export const RN_WEBVIEW_MESSAGE_TYPES = {
  RESERVATION_CREATED: 'reservation_created',
  RESERVATION_CANCELED: 'reservation_canceled',
  RESERVATION_UPDATED: 'reservation_updated',
  RESERVATION_REQUEST_CREATED: 'reservation_request_created',
  RESERVATION_REQUEST_UPDATED: 'reservation_request_updated',
  MobileApp: 'mobile_app',
};

export const SIDEBAR_WIDTH = 350;

export const EMAIL_MESSAGE_STATUSES = {
  SENT: 'sent',
  DELIVERED: 'delivered',
  FAILED: 'failed',
};

export const MARKETING_EMAIL_TEMPLATES_TYPES = {
  WELCOME: 'welcome',
  WE_MISS_YOU: 'we_miss_you',
  HAPPY_FRIDAY: 'happy_friday',
  LAZY_SUNDAY: 'lazy_sunday',
  LOYALTY_PROGRAM: 'loyalty_program',
  YOU_MIGHT_ALSO_LIKE: 'you_might_also_like',
  STOREFRONT_PROMO: 'storefront_promo',
};

export const IntegrationService = {
  Tabless: 'tabless',
  WinOrder: 'win_order',
  ExpertOrder: 'expert_order',
  Deliverect: 'deliverect',
  Liefersoft: 'liefersoft',
  Hubrise: 'hubrise',
};

// Human-facing brand names, identical across locales (so not in the i18n files).
export const IntegrationServiceName = {
  [IntegrationService.Tabless]: 'Tabless',
  [IntegrationService.WinOrder]: 'WinOrder',
  [IntegrationService.ExpertOrder]: 'ExpertOrder',
  [IntegrationService.Deliverect]: 'Deliverect',
  [IntegrationService.Liefersoft]: 'Liefersoft',
  [IntegrationService.Hubrise]: 'HubRise',
};

export const OperationalStatusErrors = [
  { key: 'name', url: ScreenEnum.MyStoreSettings },
  { key: 'logo_url', url: ScreenEnum.MyStoreGallery },
  { key: 'pictures', url: ScreenEnum.MyStoreGallery },
  { key: 'menu_uploaded', url: ScreenEnum.Menu },
  { key: 'opening_hours', url: ScreenEnum.OpeningHours },
  { key: 'address', url: ScreenEnum.Locations },
  { key: 'master_promo_code', url: ScreenEnum.MarketingPromoCodes },
  { key: 'flyers_ordered', url: ScreenEnum.MarketingPolygraphyProducts },
  { key: 'test_orders', url: ScreenEnum.SalesOrders },
  { key: 'stripe_billing', url: ScreenEnum.PaymentGateways },
  { key: 'payments_configured', url: ScreenEnum.PaymentGateways },
  { key: 'storefront', url: ScreenEnum.WebsiteStorefront },
  { key: 'google_business', url: ScreenEnum.MarketingGoogleBusiness },
  // Billing prerequisites for a partner on platform billing. LiveOrdersDrawer
  // filters this static list by the keys the server returned, so a key missing
  // here is silently dropped and the partner sees a failed launch with no
  // reason at all. Both point at Partner Billing: it is where a payment method
  // is added, and where the restaurant's licences are listed. The paywall
  // modal is the primary way `billing_license` gets resolved, but the row still
  // needs a real screen — a null url crashed the takeout page once (FOO-3249).
  { key: 'billing_payment_method', url: ScreenEnum.PartnerBilling },
  { key: 'billing_license', url: ScreenEnum.PartnerBilling },
  // The payment gate on a self-serve partner's first launch (PRD 8.8). Only a
  // super admin can waive them, and only by skipping them from this list.
  { key: 'business_name', url: ScreenEnum.RestaurantOnboarding },
  { key: 'payment_method', url: ScreenEnum.OrderSettingsPaymentMethods },
  // A destination partner's Stripe processing fee, on every launch. Only a super
  // admin can waive it.
  { key: 'stripe_processing_fee', url: ScreenEnum.PartnerProcessingFees },
];

export const GoogleBusinessDays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

export const GoogleBusinessPageUrlTypes = [
  'APPOINTMENT',
  'ONLINE_APPOINTMENT',
  'DINING_RESERVATION',
  'FOOD_ORDERING',
  'FOOD_DELIVERY',
  'FOOD_TAKEOUT',
  'SHOP_ONLINE',
];

export const DIETARY_ATTRIBUTES = {
  VEGETARIAN: 'vegetarian',
  VEGAN: 'vegan',
  HALAL: 'halal',
  GLUTEN_FREE: 'gluten_free',
  DAIRY_FREE: 'dairy_free',
  SPICY: 'spicy',
};

export const OPENAI_ROLES = {
  SYSTEM: 'system',
  USER: 'user',
  ASSISTANT: 'assistant',
};

export const OPENAI_MODELS = {
  GTP_4_MINI: 'gpt-4o-mini',
  GTP_4_TURBO: 'gpt-4-turbo',
  GTP_4: 'gpt-4o',
};

export const TrackingLinkType = {
  Auto: 'auto',
  Manual: 'manual',
};

export const TrackingLinkTargetProduct = {
  Storefront: 'storefront',
  Shop: 'shop',
  Custom: 'custom',
};

export const UtmSource = {
  Flyer: 'flyer',
  Email: 'email',
  Google: 'google',
  GoogleBusinessProfile: 'google_business_profile',
  Facebook: 'facebook',
  Instagram: 'instagram',
  Pinterest: 'pinterest',
  Tiktok: 'tiktok',
  SocialMedia: 'social_media',
};

export const UtmMedium = {
  QrCode: 'qr_code',
  Button: 'button',
  Ad: 'ad',
  Post: 'post',
};

export const GOOGLE_ADS_CAMPAIGN_STATUS = {
  UNSPECIFIED: 0,
  UNKNOWN: 1,
  ENABLED: 2,
  PAUSED: 3,
  REMOVED: 4,
};

export const GoogleAdsCampaignConnectionStatus = {
  Connected: 'connected',
  NotConnected: 'not_connected',
};

export const TeamReportFormat = {
  JSON: 'json',
  File: 'file',
};

export const TeamReportType = {
  Sales: 'sales',
  SignedLive: 'signed_live',
  MRR: 'mrr',
  SalesCommission: 'sales_commission',
};

export const CompanyOperationalStatus = {
  Live: 'live',
  Paused: 'paused',
  Suspended: 'suspended',
};

export const ReservationOccasion = {
  Birthday: 'birthday',
  Anniversary: 'anniversary',
  Date: 'date',
  SpecialOccasion: 'special_occasion',
  BusinessMeal: 'business_meal',
};

export const MobileAppReleaseStatus = {
  Backlog: null,
  ReadyToBuild: 'ready_to_build',
  InWork: 'in_work',
  InReview: 'in_review',
  Rejected: 'rejected',
  Released: 'released',
  Deactivated: 'deactivated',
};

export const MobileAppReleaseStatusColumns = [
  'backlog',
  'ready_to_build',
  'in_work',
  'in_review',
  'rejected',
  'released',
  'deactivated',
];

export const MobileAppReleaseStatusTag = {
  HasTechIssue: 'has_tech_issue',
};

export const ProductPackagingType = {
  Packaged: 'packaged',
  Prepared: 'prepared',
};

export const CompanyTier = {
  Vip: 1,
  Star: 2,
  B: 3,
  C: 4,
  D: 5,
};

export const ProductAllergens = {
  DairyMilk: 'dairy',
  Eggs: 'eggs',
  Fish: 'fish',
  Gluten: 'gluten',
  Mango: 'mango',
  Peanuts: 'peanuts',
  Sesame: 'sesame',
  Shellfish: 'shellfish',
  Soy: 'soy',
  TreeNuts: 'tree_nuts',
  Celery: 'celery',
  Crustaceans: 'crustaceans',
  Lupin: 'lupin',
  Molluscs: 'molluscs',
  Mustard: 'mustard',
  Nuts: 'nuts',
  Sulphites: 'sulphites',
  Almonds: 'almonds',
  Barley: 'barley',
  BrazilNuts: 'brazil_nuts',
  Cashew: 'cashew',
  Hazelnuts: 'hazelnuts',
  Kamut: 'kamut',
  Macadamia: 'macadamia',
  Oats: 'oats',
  Pecan: 'pecan',
  Pistachios: 'pistachios',
  Rye: 'rye',
  Spelt: 'spelt',
  Walnuts: 'walnuts',
  Wheat: 'wheat',
  SugaredDrink: 'sugared_drink',
  Lentils: 'lentils',
  QueenslandNuts: 'queensland_nuts',
};

export const ProductAdditives = {
  AcesulfamK: 'acesulfame_k',
  AceSucralose: 'ace_sucralose',
  Aesculin: 'aesculin',
  Agar: 'agar',
  Anthocyanin: 'anthocyanin',
  Antioxidant: 'antioxidant',
  AntioxidantAscorbicAcid: 'antioxidant_ascorbic_acid',
  AntioxidantTocopherols: 'antioxidant_tocopherols',
  Flavor: 'flavor',
  Flavors: 'flavors',
  AscorbicAcid: 'ascorbic_acid',
  Aspartame: 'aspartame',
  OysterSauce: 'oyster_sauce',
  BakingAid: 'baking_aid',
  BakingPowder: 'baking_powder',
  BalsamicVinegar: 'balsamic_vinegar',
  BalsamicCream: 'balsamic_cream',
  BasilPesto: 'basil_pesto',
  BenzoicAcid: 'benzoic_acid',
  BetaCarotene: 'beta_carotene',
  Betain: 'betain',
  BeetrootRed: 'beetroot_red',
  Beeswax: 'beeswax',
  Bitters: 'bitters',
  BlueCuracao: 'blue_curacao',
  BlueCuracaoSyrup: 'blue_curacao_syrup',
  BrandyVinegar: 'brandy_vinegar',
  Broth: 'broth',
  Caffeine: 'caffeine',
  Calcium: 'calcium',
  Caramel: 'caramel',
  CaramelColor: 'caramel_color',
  CaramelE150d: 'caramel_e150d',
  Carotene: 'carotene',
  CayennePepper: 'cayenne_pepper',
  Chili: 'chili',
  ChiliDressing: 'chili_dressing',
  ChiliMayonnaise: 'chili_mayonnaise',
  ChiliOil: 'chili_oil',
  Quinine: 'quinine',
  Chlorophyll: 'chlorophyll',
  CitricAcid: 'citric_acid',
  CitrusAcid: 'citrus_acid',
  CarbonDioxide: 'carbon_dioxide',
  CocktailSauce: 'cocktail_sauce',
  Curry: 'curry',
  CurryPaste: 'curry_paste',
  CurryPowder: 'curry_powder',
  CurryCreamSauce: 'curry_cream_sauce',
  Fragrance: 'fragrance',
  E100: 'E100',
  E101: 'E101',
  E102: 'E102',
  E103: 'E103',
  E104: 'E104',
  E110: 'E110',
  E1103: 'E1103',
  E120: 'E120',
  E122: 'E122',
  E124: 'E124',
  E129: 'E129',
  E131: 'E131',
  E132: 'E132',
  E133: 'E133',
  E140: 'E140',
  E1400: 'E1400',
  E141: 'E141',
  E1420: 'E1420',
  E1422: 'E1422',
  E150a: 'E150a',
  E150c: 'E150c',
  E150d: 'E150d',
  E151: 'E151',
  E1510: 'E1510',
  E1511: 'E1511',
  E153: 'E153',
  E160a: 'E160a',
  E160c: 'E160c',
  E160e: 'E160e',
  E161b: 'E161b',
  E162: 'E162',
  E163: 'E163',
  E171: 'E171',
  E172: 'E172',
  E200: 'E200',
  E202: 'E202',
  E211: 'E211',
  E220: 'E220',
  E235: 'E235',
  E250: 'E250',
  E251: 'E251',
  E252: 'E252',
  E260: 'E260',
  E262: 'E262',
  E270: 'E270',
  E282: 'E282',
  E290: 'E290',
  E296: 'E296',
  E300: 'E300',
  E301: 'E301',
  E306: 'E306',
  E307: 'E307',
  E319: 'E319',
  E322: 'E322',
  E330: 'E330',
  E331: 'E331',
  E338: 'E338',
  E339: 'E339',
  E341: 'E341',
  E400: 'E400',
  E401: 'E401',
  E406: 'E406',
  E407: 'E407',
  E410: 'E410',
  E412: 'E412',
  E414: 'E414',
  E415: 'E415',
  E420: 'E420',
  E440: 'E440',
  E442: 'E442',
  E450: 'E450',
  E451: 'E451',
  E466: 'E466',
  E471: 'E471',
  E472: 'E472',
  E473: 'E473',
  E476: 'E476',
  E500: 'E500',
  E620: 'E620',
  E621: 'E621',
  E627: 'E627',
  E631: 'E631',
  E635: 'E635',
  E950: 'E950',
  E951: 'E951',
  E955: 'E955',
  E960: 'E960',
  E961: 'E961',
  E962: 'E962',
  E965: 'E965',
};

export const ScriptStrategies = {
  AfterInteractive: 'afterInteractive',
  LazyOnload: 'lazyOnload',
  BeforeInteractive: 'beforeInteractive',
};

// Platform-wide ceilings for the consumer service fee — mirrors the backend
// App\Constants\ServiceFee\ServiceFeeHardLimits (display-only; the backend
// enforces them at save and checkout). Amounts are in minor units.
export const SERVICE_FEE_HARD_LIMITS = {
  max_percentage: 5,
  min_amount: 36,
  max_amount: 129,
};

// The service fee FoodAmigos recommends partners charge — shown as a hint on
// the fee inputs and in the revenue calculator. Mirrors the backend's
// `recommended` block; the max amount is in minor units.
export const SERVICE_FEE_RECOMMENDED = {
  percentage: 4,
  max_amount: 129,
};
